<template>
  <div class="act_lottery_nine" v-if="awards && awards.length === 8">
    <div class="box-row">
      <div class="unit">
        <div :style="current===0?selected_style:unselect_style">
          <img :src="awards[0].icon" width="100%"/>
        </div>
      </div>
      <div class="unit">
        <div :style="current===1?selected_style:unselect_style">
          <img :src="awards[1].icon" width="100%"/>
        </div>
      </div>
      <div class="unit">
        <div :style="current===2?selected_style:unselect_style">
          <img :src="awards[2].icon" width="100%"/>
        </div>
      </div>
    </div>
    <div class="box-row">
      <div class="unit">
        <div :style="current===7?selected_style:unselect_style">
          <img :src="awards[7].icon" width="100%"/>
        </div>
      </div>
      <div class="unit" @click.prevent="lottery">
        <img :src="lottery_btn">
      </div>
      <div class="unit">
        <div :style="current===3?selected_style:unselect_style">
          <img :src="awards[3].icon" width="100%"/>
        </div>
      </div>
    </div>
    <div class="box-row">
      <div class=" unit">
        <div :style="current===6?selected_style:unselect_style">
          <img :src="awards[6].icon" width="100%"/>
        </div>
      </div>
      <div class="unit">
        <div :style="current===5?selected_style:unselect_style">
          <img :src="awards[5].icon" width="100%"/>
        </div>
      </div>
      <div class="unit">
        <div :style="current===4?selected_style:unselect_style">
          <img :src="awards[4].icon" width="100%"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import click_handler from '../../../tools/mgtv/click'
  import {click_event} from '../../../tools/mgtv/analysis'

  import to_casher from '../../../tools/mgtv/casher'
  import {openLink} from '../../../tools/mgtv/link'
  import download from '../../../tools/mgtv/downapp'
  import {getJSON} from '../../../api/myaxios'
  import process_award from './process_award'
  import {process_error_action} from '../../../tools/mgtv/error_action'
  import {GET_REMAIN_TIMES} from '../../../constant/eventbus'
  import {onUseInfoLoad} from '../../../tools/onUseInfoLoad'

  const SPEED = 150;
  export default {
    name: "ActLotteryNine",
    props: {
      info: {
        type: Object
      }
    },
    data() {
      return {
        awards: [],
        current: -1,
        award_info: null
      }
    },
    computed: {
      lottery_btn() {
        return this.info.ning_btn || "//vipcdn.mgtv.com/mrdb/2018/mama/imgs/btn_lottery.png"
      },

      selected_style() {
        const img = this.info.ning_award_bg_h || '//vipcdn.mgtv.com/mrdb/2018/mama/imgs/btn_selected.png'
        return {
          background: `url(${img}) 0% 0% / cover no-repeat`,
        }
      },
      unselect_style() {
        const img = this.info.ning_award_bg || '//vipcdn.mgtv.com/mrdb/2018/mama/imgs/btn_unselect.png'
        return {
          background: `url(${img}) 0% 0% / cover no-repeat`,
        }
      },
    },
    methods: {
      lottery_from_remote() {
        this.award_info = null;

        window.$toast.loading({
          mask: false,
          forbidClick: true, // 禁用背景点击
          message: '正在请求....',
          duration: 10000
        });

        getJSON("//vipact3.api.mgtv.com/api/v1/act/lot/lot", {
          act_name: window.rootdata.act_name,
          ticket: window.$bus.user.ticket
        }).then(res => {
          window.$toast.clear();
          if (!res) {
            window.$toast('请求超时，请重试');
            click_event('抽奖超时')
            return;
          }
          if (res && res.ret === 0) {
            this.award_info = res.data;
            Vue.set(window.$bus.lottery, 'remain_chance', res.data.remain_chance);
            this.start_roll();
            click_event('抽奖成功')
          } else {
            process_error_action(res.data.action, res.msg);
          }
        }).catch(e => {
          window.$toast.clear();
          window.$toast('抽奖失败,请重试')
          click_event('抽奖异常')
        })
      },
      fetchPrizes() {
        getJSON("//vipact3.api.mgtv.com/api/v1/act/lot/award/list", {act_name: window.rootdata.act_name}).then(res => {
          if (res && res.ret === 0) {
            if (res.data.list.length !== 8) {
              window.$toast('九宫格奖品数量不足');
              return;
            }
            this.awards = res.data.list;
          }
        })
      },
      stop_roll() {
        if (this.interval) {
          window.clearInterval(this.interval);
          this.interval = null;
        }
        setTimeout(() => {
          process_award(this.award_info);
        }, 200);
      },
      lottery() {
        if(this.interval){
          //还在转，禁止抽奖
          return;
        }
        click_handler(this.info.name + '-抽奖按钮', this.lottery_from_remote, {
          need_login: true,
          need_act: true,
          need_new_user: false,
          need_vip_level: -1,
        });
      },
      start_roll() {
        if (this.interval) {
          return;
        }
        //start rolling
        let roll_count = 0;
        this.interval = setInterval(() => {
          //rolling
          this.current = ( this.current + 1 ) % 8;
          roll_count += 1;

          //维持最小滚动次数
          if (roll_count < 12) {
            return;
          }
          //stop rolling
          if (this.award_info && this.award_info.award_id === this.awards[this.current % 8].id) {
            this.stop_roll('success');
          }

        }, SPEED);
      }
    },
    created() {
      this.fetchPrizes();
      onUseInfoLoad(()=>{
        window.$bus.$emit(GET_REMAIN_TIMES);
      })

    }

  }
</script>
<style lang="stylus">
  .act_lottery_nine
    width 6.3rem
    height 6.3rem
    position: relative
    display flex
    flex-direction column
    justify-content space-between
    .box-row
      display flex
      justify-content space-between
    .unit
      width 1.96rem
      height 1.96rem
      img
        width @width
        height @height
        display block


</style>





// WEBPACK FOOTER //
// src/components/ConfigUI/Lottery/ActLotteryNine.vue